const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export type ParsedQrStorageEntity =
  | { box_id: string }
  | { item_id: string }
  | { user_id: string }
  | { cell_id: string };

/** QR: UUID, URL with `/boxes/:id`, `/items/:id`, `/users/:id`, `/cells/:id`, or UUID in the last path segment. */
export function parseQrToBoxOrItemId(
  raw: string,
): ParsedQrStorageEntity | null {
  const trimmed = raw.trim();
  try {
    const u = new URL(trimmed);
    const parts = u.pathname.split('/').filter(Boolean);
    const last = parts[parts.length - 1];
    if (last && UUID_RE.test(last)) {
      const itemsIdx = parts.indexOf('items');
      if (itemsIdx >= 0 && itemsIdx === parts.length - 2) {
        return { item_id: last };
      }
      const boxesIdx = parts.indexOf('boxes');
      if (boxesIdx >= 0 && boxesIdx === parts.length - 2) {
        return { box_id: last };
      }
      const usersIdx = parts.indexOf('users');
      if (usersIdx >= 0 && usersIdx === parts.length - 2) {
        return { user_id: last };
      }
      const cellsIdx = parts.indexOf('cells');
      if (cellsIdx >= 0 && cellsIdx === parts.length - 2) {
        return { cell_id: last };
      }
      return { box_id: last };
    }
  } catch {
    /* ignore */
  }
  if (UUID_RE.test(trimmed)) {
    return { box_id: trimmed };
  }
  return null;
}
